import actions from './mapAPIActions'

export default {
  namespaced: true,
  actions,
}
